var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.9,25.2H40.1C20.7,25.2,5,40.9,5,60.2c0,0,0.2,153,0.2,206.9c0,6.8,8.3,10.3,13.1,5.4l48.5-48.5h193.1 c19.4,0,35.1-15.7,35.1-35.1V60.2C295,40.9,279.3,25.2,259.9,25.2z M235.9,149.6c-1.5,1.5-3.5,2.4-5.8,2.4H73.3 c-4.5,0-8.1-3.6-8.1-8.1c0-2.2,0.9-4.3,2.4-5.8c1.5-1.5,3.5-2.4,5.8-2.4h156.9c4.5,0,8.2,3.6,8.2,8.2 C238.3,146.1,237.4,148.1,235.9,149.6z M235.9,105.1c-1.5,1.5-3.5,2.4-5.8,2.4H73.3c-4.5,0-8.1-3.6-8.1-8.1c0-2.2,0.9-4.3,2.4-5.8 c1.5-1.5,3.5-2.4,5.8-2.4h156.9c4.5,0,8.2,3.7,8.2,8.2C238.3,101.6,237.4,103.6,235.9,105.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat2);
export default __webpack_public_path__ + "static/media/Chat2.4aad4dad3ff58cc6e40585c226208f24.svg";
export { ForwardRef as ReactComponent };